
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { CheckInTable } from "@/components/check-in/check-in-table"
import { PageHeader } from "@/components/shared/page-header"
import { Card, CardContent } from "@/components/ui/card"

export default function CheckInPage() {
  const { t } = useTranslation()
  const [refreshKey] = useState(0)

  return (
    <div className="space-y-6">
      <PageHeader title={t("checkIn.title")} />
      <Card>
        <CardContent className="pt-6">
          <CheckInTable key={refreshKey} />
        </CardContent>
      </Card>
    </div>
  )
}
